module.exports = __webpack_public_path__ + "2fc136a8f1f35035bc4ba210e1fb924b.svg";